import { configureStore, Middleware } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { securedAppApi } from './api/securedApi';
import authReducer from './slices/authSlice';
import AzureAuthReducer from './slices/azureAuthSlice';
import BankAccountReducer from './slices/bankaccountSlice';
import companyReducer from './slices/companySlice';
import customerReducer from './slices/customerSlice';
import dashboardReducer from './slices/dashboardSlice';
import locationReducer from './slices/LocationSlice';
import rolesReducer from './slices/rolesSlice';
import signatoriesReducer from './slices/signatoriesSlice';
import teamReducer from './slices/teammemberSlice';

const loggingMiddleware: Middleware = _storeAPI => next => (action: unknown) => {
  // if (
  //   typeof action === 'object' &&
  //   action !== null &&
  //   'type' in action &&
  //   typeof (action as Record<string, unknown>).type === 'string'
  // ) {
  //   const type = (action as Action).type;
  //   if (type.startsWith('securedAppApi/')) {
  //     console.log('[API CALL]', action);
  //   } else {
  //     console.log('[Redux Action]', action);
  //   }
  // } 
  // else {
  //   console.log('[Unknown Action]', action);
  // }
  return next(action);
};

export const store = configureStore({
  reducer: {
    securedAppApi: securedAppApi.reducer, // <-- THE FIX IS HERE
    auth: authReducer,
    azureAuth: AzureAuthReducer,
    dashboard: dashboardReducer,
    company: companyReducer,
    customer: customerReducer,
    location: locationReducer,
    signatories: signatoriesReducer,
    roles: rolesReducer,
    teammember: teamReducer,
    bankaccount: BankAccountReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(loggingMiddleware) // Add custom logging middleware
      .concat(securedAppApi.middleware),
  devTools: !import.meta.env.PROD, // Enable Redux DevTools in development mode
});

// Infer the `RootState` type from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Create typed hooks for Redux
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
